// // export const API_BASE_URL = "http://localhost:5080/api";

// export const API_BASE_URL = "https://yadnya.azurewebsites.net/api";

// export const API_ENDPOINTS = {
//   login: "/admin/login",

//   products: "/products",
//   product: (id) => `/products/${id}`,

//   createProduct: "/products",
//   updateProduct: (id) => `/products/${id}`,

//   updatePrice: (id) => `/products/${id}/price`,

//   deleteProduct: (id) => `/products/${id}`,

//   categories: "/categories",
// };

// const getResponseData = async (response) => {
//   const data = await response.json().catch(() => ({}));

//   if (!response.ok) {
//     throw new Error(
//       data.message ||
//         data.title ||
//         data.error ||
//         `Request failed with status ${response.status}`,
//     );
//   }

//   return data;
// };

// /*
//   Common JWT headers
// */
// const getAuthHeaders = (token) => {
//   if (!token) {
//     throw new Error("Authentication token is missing. Please login again.");
//   }

//   return {
//     Authorization: `Bearer ${token}`,
//   };
// };

// export const adminApi = {
//   // =========================================================
//   // LOGIN
//   // =========================================================

//   async login(email, password) {
//     const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.login}`, {
//       method: "POST",

//       headers: {
//         "Content-Type": "application/json",
//       },

//       body: JSON.stringify({
//         email,
//         password,
//       }),
//     });

//     return getResponseData(response);
//   },

//   // =========================================================
//   // GET PRODUCTS
//   // =========================================================

//   async getProducts(token) {
//     const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.products}`, {
//       method: "GET",
//       cache: "no-store",
//       headers: {
//         ...getAuthHeaders(token),
//         "Cache-Control": "no-cache",
//         Pragma: "no-cache",
//       },
//     });

//     return getResponseData(response);
//   },

//   // =========================================================
//   // GET SINGLE PRODUCT
//   // =========================================================

//   async getProduct(id, token) {
//     const response = await fetch(
//       `${API_BASE_URL}${API_ENDPOINTS.product(id)}`,
//       {
//         method: "GET",

//         headers: {
//           ...getAuthHeaders(token),
//         },
//       },
//     );

//     return getResponseData(response);
//   },

//   // =========================================================
//   // GET ALL CATEGORIES
//   // =========================================================

//   async getCategories(token) {
//     const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.categories}`, {
//       method: "GET",

//       headers: {
//         ...getAuthHeaders(token),
//       },
//     });

//     return getResponseData(response);
//   },

//   // =========================================================
//   // CREATE PRODUCT
//   // =========================================================

//   async createProduct(product, token) {
//     if (!token) {
//       throw new Error("Authentication token is missing.");
//     }

//     const formData = new FormData();

//     formData.append("Name", product.name);
//     formData.append("Category", product.category);
//     formData.append("Price", String(product.price));

//     if (product.oldPrice !== undefined && product.oldPrice !== "") {
//       formData.append("OldPrice", String(product.oldPrice));
//     }

//     // if (product.videoFile instanceof File) {
//     //   formData.append("VideoFile", product.videoFile);
//     // }

//     formData.append("Description", product.description || "");

//     formData.append("SoldOut", product.soldOut ? "true" : "false");

//     formData.append("IsNewArrival", product.isNewArrival ? "true" : "false");

//     formData.append("IsSignature", product.isSignature ? "true" : "false");

//     formData.append("IsRare", product.isRare ? "true" : "false");

//     /*
//       Multiple images

//       IMPORTANT:
//       product.images must contain actual File objects.
//     */
//     if (product.images && product.images.length > 0) {
//       product.images.forEach((file) => {
//         if (file instanceof File) {
//           formData.append("Images", file);
//         }
//       });
//     }

//     const response = await fetch(
//       `${API_BASE_URL}${API_ENDPOINTS.createProduct}`,
//       {
//         method: "POST",

//         headers: {
//           ...getAuthHeaders(token),
//         },

//         body: formData,
//       },
//     );

//     return getResponseData(response);
//   },

//   // =========================================================
//   // UPDATE PRODUCT
//   // =========================================================

//   async updateProduct(id, product, token) {
//     const formData = new FormData();

//     formData.append("Name", product.name);
//     formData.append("Category", product.category);
//     formData.append("Price", String(product.price));

//     if (product.oldPrice !== undefined && product.oldPrice !== "") {
//       formData.append("OldPrice", String(product.oldPrice));
//     }

//     // if (product.videoFile instanceof File) {
//     //   formData.append("VideoFile", product.videoFile);
//     // }

//     formData.append("Description", product.description || "");

//     formData.append("SoldOut", product.soldOut ? "true" : "false");

//     formData.append("IsNewArrival", product.isNewArrival ? "true" : "false");

//     formData.append("IsSignature", product.isSignature ? "true" : "false");

//     formData.append("IsRare", product.isRare ? "true" : "false");

//     if (product.images && product.images.length > 0) {
//       product.images.forEach((file) => {
//         if (file instanceof File) {
//           formData.append("Images", file);
//         }
//       });
//     }

//     const response = await fetch(
//       `${API_BASE_URL}${API_ENDPOINTS.updateProduct(id)}`,
//       {
//         method: "PUT",

//         headers: {
//           ...getAuthHeaders(token),
//         },

//         body: formData,
//       },
//     );

//     return getResponseData(response);
//   },

//   // =========================================================
//   // UPDATE PRODUCT PRICE
//   // =========================================================

//   async updateProductPrice(id, price, token) {
//     const response = await fetch(
//       `${API_BASE_URL}${API_ENDPOINTS.updatePrice(id)}`,
//       {
//         method: "PUT",

//         headers: {
//           "Content-Type": "application/json",

//           ...getAuthHeaders(token),
//         },

//         body: JSON.stringify({
//           price: Number(price),
//         }),
//       },
//     );

//     return getResponseData(response);
//   },

//   // =========================================================
//   // DELETE PRODUCT
//   // =========================================================

//   async deleteProduct(id, token) {
//     const response = await fetch(
//       `${API_BASE_URL}${API_ENDPOINTS.deleteProduct(id)}`,
//       {
//         method: "DELETE",

//         headers: {
//           ...getAuthHeaders(token),
//         },
//       },
//     );

//     return getResponseData(response);
//   },
// };

import { clearAdminAuth } from "./adminStorage";

// API BASE URL
// export const API_BASE_URL = "http://localhost:5080/api";
export const API_BASE_URL = "https://yadnya.azurewebsites.net/api";

// API ENDPOINTS
export const API_ENDPOINTS = {
  login: "/admin/login",
  verifyToken: "/admin/verify",

  products: "/products",
  product: (id) => `/products/${id}`,

  createProduct: "/products",
  updateProduct: (id) => `/products/${id}`,

  updatePrice: (id) => `/products/${id}/price`,
  deleteProduct: (id) => `/products/${id}`,

  categories: "/categories",
};

// =========================================================
// COMMON RESPONSE HANDLER
// =========================================================

const getResponseData = async (response) => {
  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(
      data.message ||
        data.title ||
        data.error ||
        `Request failed with status ${response.status}`,
    );
  }

  return data;
};

// =========================================================
// PROTECTED API RESPONSE HANDLER
// Automatically handles expired/invalid JWT
// =========================================================

const getProtectedResponseData = async (response) => {
  if (response.status === 401) {
    clearAdminAuth();

    window.location.replace("/admin/login");

    throw new Error("Session expired. Please login again.");
  }

  return getResponseData(response);
};

// =========================================================
// COMMON JWT HEADERS
// =========================================================

const getAuthHeaders = (token) => {
  if (!token) {
    clearAdminAuth();

    throw new Error("Authentication token is missing. Please login again.");
  }

  return {
    Authorization: `Bearer ${token}`,
  };
};

// =========================================================
// ADMIN API
// =========================================================

export const adminApi = {
  // =======================================================
  // LOGIN
  // =======================================================

  async login(email, password) {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.login}`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        email,
        password,
      }),
    });

    // Login uses normal response handling.
    // Invalid credentials should show an error on login page.
    return getResponseData(response);
  },

  // =======================================================
  // VERIFY JWT TOKEN
  // =======================================================

  async verifyToken(token) {
    const response = await fetch(
      `${API_BASE_URL}${API_ENDPOINTS.verifyToken}`,
      {
        method: "GET",
        cache: "no-store",
        headers: {
          ...getAuthHeaders(token),
          "Cache-Control": "no-cache",
          Pragma: "no-cache",
        },
      },
    );

    return getProtectedResponseData(response);
  },

  // =======================================================
  // GET ALL PRODUCTS
  // =======================================================

  async getProducts(token) {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.products}`, {
      method: "GET",
      cache: "no-store",
      headers: {
        ...getAuthHeaders(token),
        "Cache-Control": "no-cache",
        Pragma: "no-cache",
      },
    });

    return getProtectedResponseData(response);
  },

  // =======================================================
  // GET SINGLE PRODUCT
  // =======================================================

  async getProduct(id, token) {
    const response = await fetch(
      `${API_BASE_URL}${API_ENDPOINTS.product(id)}`,
      {
        method: "GET",
        headers: {
          ...getAuthHeaders(token),
        },
      },
    );

    return getProtectedResponseData(response);
  },

  // =======================================================
  // GET ALL CATEGORIES
  // =======================================================

  async getCategories(token) {
    const response = await fetch(`${API_BASE_URL}${API_ENDPOINTS.categories}`, {
      method: "GET",
      headers: {
        ...getAuthHeaders(token),
      },
    });

    return getProtectedResponseData(response);
  },

  // =======================================================
  // CREATE PRODUCT
  // =======================================================

  async createProduct(product, token) {
    const formData = new FormData();

    formData.append("Name", product.name);
    formData.append("Category", product.category);
    formData.append("Price", String(product.price));

    if (product.oldPrice !== undefined && product.oldPrice !== "") {
      formData.append("OldPrice", String(product.oldPrice));
    }

    formData.append("Description", product.description || "");

    formData.append("SoldOut", product.soldOut ? "true" : "false");

    formData.append("IsNewArrival", product.isNewArrival ? "true" : "false");

    formData.append("IsSignature", product.isSignature ? "true" : "false");

    formData.append("IsRare", product.isRare ? "true" : "false");

    // Multiple product images
    if (product.images && product.images.length > 0) {
      product.images.forEach((file) => {
        if (file instanceof File) {
          formData.append("Images", file);
        }
      });
    }

    const response = await fetch(
      `${API_BASE_URL}${API_ENDPOINTS.createProduct}`,
      {
        method: "POST",
        headers: {
          ...getAuthHeaders(token),
        },
        body: formData,
      },
    );

    return getProtectedResponseData(response);
  },

  // =======================================================
  // UPDATE PRODUCT
  // =======================================================

  async updateProduct(id, product, token) {
    const formData = new FormData();

    formData.append("Name", product.name);
    formData.append("Category", product.category);
    formData.append("Price", String(product.price));

    if (product.oldPrice !== undefined && product.oldPrice !== "") {
      formData.append("OldPrice", String(product.oldPrice));
    }

    formData.append("Description", product.description || "");

    formData.append("SoldOut", product.soldOut ? "true" : "false");

    formData.append("IsNewArrival", product.isNewArrival ? "true" : "false");

    formData.append("IsSignature", product.isSignature ? "true" : "false");

    formData.append("IsRare", product.isRare ? "true" : "false");

    if (product.images && product.images.length > 0) {
      product.images.forEach((file) => {
        if (file instanceof File) {
          formData.append("Images", file);
        }
      });
    }

    const response = await fetch(
      `${API_BASE_URL}${API_ENDPOINTS.updateProduct(id)}`,
      {
        method: "PUT",
        headers: {
          ...getAuthHeaders(token),
        },
        body: formData,
      },
    );

    return getProtectedResponseData(response);
  },

  // =======================================================
  // UPDATE PRODUCT PRICE
  // =======================================================

  async updateProductPrice(id, price, token) {
    const response = await fetch(
      `${API_BASE_URL}${API_ENDPOINTS.updatePrice(id)}`,
      {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          ...getAuthHeaders(token),
        },
        body: JSON.stringify({
          price: Number(price),
        }),
      },
    );

    return getProtectedResponseData(response);
  },

  // =======================================================
  // DELETE PRODUCT
  // =======================================================

  async deleteProduct(id, token) {
    const response = await fetch(
      `${API_BASE_URL}${API_ENDPOINTS.deleteProduct(id)}`,
      {
        method: "DELETE",
        headers: {
          ...getAuthHeaders(token),
        },
      },
    );

    return getProtectedResponseData(response);
  },
};
